export function isObject(value: any): boolean {
  return typeof value == 'object' && value !== null && value.constructor == Object;
}
